import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Doug C. Hardester
 * id C6664923-EE26-4175-90CB-AD87B517F2FF
 * name trophy-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/trophy-variant.svg
 * tags
 * - Sport 
 */
export const TrophyVariantIcon = createSvgIcon(<><path d="M17 4V2H7V4H2V11C2 12.1 2.9 13 4 13H7.1C7.5 14.96 9.04 16.5 11 16.9V19.08C8 19.54 8 22 8 22H16C16 22 16 19.54 13 19.08V16.9C14.96 16.5 16.5 14.96 16.9 13H20C21.1 13 22 12.1 22 11V4H17M4 11V6H7V11L4 11M20 11L17 11V6H20L20 11Z" /></>, 'TrophyVariantIcon');
export default TrophyVariantIcon